import { Layout } from "@/components/Layout";
import { Outlet } from "react-router-dom";

export const LayoutRoute = () => (
  <Layout>
    <Outlet />
  </Layout>
);
